import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-323.56 -348.44 2311.11 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1408 544V64Q1408 38 1389.0 19.0Q1370 0 1344 0H960V384H704V0H320Q294 0 275.0 19.0Q256 38 256 64V544Q256 545 256.5 547.0Q257 549 257 550L832 1024L1407 550Q1408 548 1408 544ZM1631 613 1569 539Q1561 530 1548 528H1545Q1532 528 1524 535L832 1112L140 535Q128 527 116 528Q103 530 95 539L33 613Q25 623 26.0 636.5Q27 650 37 658L756 1257Q788 1283 832.0 1283.0Q876 1283 908 1257L1152 1053V1248Q1152 1262 1161.0 1271.0Q1170 1280 1184 1280H1376Q1390 1280 1399.0 1271.0Q1408 1262 1408 1248V840L1627 658Q1637 650 1638.0 636.5Q1639 623 1631 613Z"
	})
});
export default SvgHomeFill;
